export default [
    {
        path: '/tmhf/:city/web_720',
        name: 'tmhf/web_720',
        component: () => import(/* webpackChunkName: "personal_package" */ '../views/tmhf/web_720/main')
    }
]
